/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CRSFSecReviewFindingLevel = {
    Critical: 'critical',
    High: 'high',
    Medium: 'medium',
    Low: 'low',
    Info: 'info'
} as const;
export type CRSFSecReviewFindingLevel = typeof CRSFSecReviewFindingLevel[keyof typeof CRSFSecReviewFindingLevel];


export function CRSFSecReviewFindingLevelFromJSON(json: any): CRSFSecReviewFindingLevel {
    return CRSFSecReviewFindingLevelFromJSONTyped(json, false);
}

export function CRSFSecReviewFindingLevelFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewFindingLevel {
    return json as CRSFSecReviewFindingLevel;
}

export function CRSFSecReviewFindingLevelToJSON(value?: CRSFSecReviewFindingLevel | null): any {
    return value as any;
}

